var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("b-table", {
        attrs: { items: _vm.items, fields: _vm.fields },
        scopedSlots: _vm._u([
          {
            key: "cell(Action)",
            fn: function (row) {
              return [
                _c(
                  "div",
                  [
                    _c(
                      "b-button",
                      {
                        attrs: { type: "Danger" },
                        on: {
                          click: function ($event) {
                            return _vm.deleteItem(row.item)
                          },
                        },
                      },
                      [_vm._v("Удалить")]
                    ),
                  ],
                  1
                ),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }